export default __webpack_public_path__ + "static/media/dice.acb988b2.webp";